export const STORE_ANNOUNCEMENTS_SEEN = "announcementsSeenIds";

export const getAnnouncementsSeen = (): string[] => {
  return JSON.parse(localStorage.getItem(STORE_ANNOUNCEMENTS_SEEN) ?? "[]");
};

export const storeAnnouncementSeen = (id: string) => {
  const announcementsSeen = getAnnouncementsSeen();
  if (announcementsSeen.includes(id)) return;
  announcementsSeen.push(id);
  localStorage.setItem(
    STORE_ANNOUNCEMENTS_SEEN,
    JSON.stringify(announcementsSeen),
  );
};
